<template>
  <div>
    <app-header v-if="step"></app-header>
    <div class="container content">
<!--      <span class="back" @click="goBack">-->
<!--        <font-awesome-icon icon="angle-left"/>-->
<!--        <span>Вернуться к выбору участника</span>-->
<!--      </span>-->
      <h1 class="center">Выберите программу</h1>
      <div class="grid">
        <table>
          <thead>
          <tr>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="result in results" :key="result.id">
            <td>
              <router-link :to="{name: 'TestStart', params: {id: result.test.id, slug: slug}}">
                <div class="btn" @click="setGroupId">«{{result.test.name}}»</div>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import TestsService from '@/services/TestsService'

  export default {
    name: 'start-test',
    data () {
      return {
        results: [],
        step: '',
        testId: '',
        testScore: ''
      }
    },
    computed: {
      slug () {
        return this.$route.params.slug
      },
      groupId () {
        return this.$store.getters.groupId
      },
      playerId () {
        return this.$store.getters.getPlayer.id
      }
    },
    methods: {
      goBack () {
        this.$emit('setPage', 1)
      },
      setGroupId (groupId) {
        this.$store.dispatch('setGroupId', groupId)
      },
      scorePoints (score, test) {
        let result = Math.floor(score * 100 / test)
        return result
      }
    },
    mounted () {
      TestsService.getTestResultsByPlayerId(this.slug, this.playerId).then(
        (response) => {
          this.results = response
          this.testId = response[0].test.id
          TestsService.getTest(this.slug, this.testId).then(
            (response) => {
              this.testScore = response.score
            }
          )
        }
      )
    }
  }
</script>

<style scoped lang="scss">
  .content {
    min-height: calc(100vh - 212px);
  }

  table {
    width: 100%;
    margin: 0;
    tr {
      th {
        color: gray;
        font-weight: 400;
      }
      td, th, td:last-child {
        text-align: center;
      }
      td {
        @media screen and (max-width: 700px) {
          padding: 3px;
        }
        padding: 10px;
        &:first-child {
          width: 50%;
          .btn {
            display: block;
            text-align: left;
            padding: 25px 20px 25px 65px;
            @media screen and (max-width: 700px) {
              padding: 10px 5px;
              font-size: 11px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/game/StartTest.vue